import React from 'react';

export default class AdvisorsHelper {
  public static getAdvisorDisplayName(advisorObj: Advisor_BasicDetails_ViewModel | User_BasicDetails_ViewModel): string {
    if (!advisorObj) {
      return '';
    }

    return [advisorObj.fullName, advisorObj.certifications].filter((v) => v).join(', ');
  }

  public static getAdvisorDisplayNameJSX(
    advisorObj: Advisor_BasicDetails_ViewModel | User_BasicDetails_ViewModel,
    fontSize: 'sm' | 'md' | 'lg'
  ): JSX.Element {
    if (!advisorObj) {
      return <></>;
    }

    const trademarkSymbol = '®';
    const certificationsContainsTrademarkSymbol = advisorObj.certifications?.includes(trademarkSymbol);

    const returnString = [advisorObj.fullName, advisorObj.certifications].filter((v) => v).join(', ');

    if (certificationsContainsTrademarkSymbol) {
      const stringParts = returnString.split(trademarkSymbol);
      let className = '';
      switch (fontSize) {
        case 'sm':
          className = 'sm';
          break;

        case 'md':
          className = 'm';
          break;

        case 'lg':
          className = 'lg';
          break;
      }

      const trademarkSymbolJSX = <span className={`font-${className}`}>{trademarkSymbol}</span>;

      if (stringParts.length > 1) {
        const stringPartsJSX: JSX.Element[] = stringParts.map((v, i) => <span key={i}>{v}</span>);
        const stringPartsJSX2 = [...stringPartsJSX];

        const iterationCount =
          stringPartsJSX.length % 2 == 0 ? Math.floor(stringPartsJSX.length / 2) : Math.floor(stringPartsJSX.length / 2) + 1;
        for (let i = 0; i < iterationCount; i++) {
          stringPartsJSX2.splice(i * 2 + 1, 0, trademarkSymbolJSX);
        }

        return (
          <React.Fragment key={0}>
            {stringPartsJSX2.map((v, i) => (
              <React.Fragment key={i}>{v}</React.Fragment>
            ))}
          </React.Fragment>
        );
      } else {
        return <span key={0}>{returnString}</span>;
      }
    } else {
      return <span key={0}>{returnString}</span>;
    }
  }
}
